export default __webpack_public_path__ + "static/media/Hair_17_F_C1.a77044e8.svg";